module.exports = __webpack_public_path__ + "img/item-08.ac124a3d.jpg";